(function($) {
    $(document).ready(function() {
        if ((".banner-with-detail").length > 0) {
            $('.banner-with-detail .header-icons .content-wrap h6').dotdotdot({
                height: 48,
                fallbackToLetter: true,
                watch: true,
            })
        }

        $('.author-info.view').each(function () {
            var $authorInfo = $(this);
            if ($authorInfo.find('.views-element-container').length !== 0) {
                $authorInfo.find('a').first().unwrap().unwrap();
            }
        });
        

        $(".banner-with-detail .content-wrap > p").wrapAll("<div class='text-wrap' />");

    });

    if ((".banner-with-detail").length > 0) {
        $(window).on('scroll', function() {
            var scroll = $(window).scrollTop();
            var off = $('.banner-with-detail').height() + 50;
            if (scroll >= off) {
                $('header').css('top', '-130px');
                $('.header-icons').addClass('show');
                $('.progress-container').show();
            } else {
                $('header').css('top', '0');
                $('.header-icons').removeClass('show');
                $('.progress-container').hide();
            }
        });
    }
    $(window).on('load', function() {
        $('.banner-with-detail.news-detail .right-bg-img').css({ 'opacity': '1' });
        if ((".banner-with-detail .row-wrap .col-left .content-wrap ul li a.bookmark").length > 0) {
            $(".banner-with-detail .row-wrap .col-left .content-wrap ul li a.bookmark").parent().addClass('bookmark-icon');
        }
    });
})(jQuery);